export default {"src":"/_next/static/media/up_vote_filled.d71491db.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};